import arrayUtil from '@/utils/arrayUtil';
import authApi from '@/api/authApi';
import { version } from '@/../package.json';

export default {
    namespaced: true,

    state: {
        version: version,
        drawer: null,
        loading: null,
        staticData: null
    },
    getters: {},
    mutations: {
        SET_DRAWER(state, value) {
            state.drawer = value;
        },
        SET_LOADING(state, value) {
            state.loading = value;
        },
        SET_STATIC_DATA(state, value) {
            state.staticData = value;
        },
        UPDATE_OR_CREATE_LOCATION(state, value) {
            arrayUtil.updateOrCreateById(state.staticData.locations, value);
            state.staticData = { ...state.staticData };
        },
        REMOVE_LOCATION_BY_ID(state, value) {
            arrayUtil.deleteById(state.staticData.locations, value);
            state.staticData = { ...state.staticData };
        }
    },
    actions: {
        async refreshStaticData({ commit }) {
            const response = await authApi.getStaticData();
            const staticData = response.data.static_data;
            commit('SET_STATIC_DATA', staticData);

            const user = response.data.user;
            if (user) {
                commit('auth/SET_AUTHENTICATED', true, { root: true });
                commit('auth/SET_USER', user, { root: true });
                console.log('Found and set authenticated user:', user.username);
            } else {
                commit('auth/SET_AUTHENTICATED', false, { root: true });
                commit('auth/SET_USER', null, { root: true });
                console.log('Authenticated user not found.');
            }
        }
    }
};
